import React, { useEffect, useState } from "react";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { clearAuthTokens } from "../../utils/Api";

const TopHeader = () => {
  const navigate = useNavigate();
  const [isLightTheme, setIsLightTheme] = useState(() => {
    const savedTheme = localStorage.getItem("isLightTheme");
    return savedTheme !== null ? JSON.parse(savedTheme) : true;
  });

  const toggleTheme = () => {
    setIsLightTheme((prevTheme) => {
      const newTheme = !prevTheme;
      localStorage.setItem("isLightTheme", JSON.stringify(newTheme));
      return newTheme;
    });
  };

  useEffect(() => {
    if (isLightTheme) {
      document.body.classList.remove("dark-mode");
    } else {
      document.body.classList.add("dark-mode");
    }
  }, [isLightTheme]);

  const logout = () => {
    try {
      clearAuthTokens();
      sessionStorage.clear();
      toast.success("Logged out successfully");
      navigate("/panel-admin/login");
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Error during logout. Please try again.");
    }
  };

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm z-20 w-full py-3 px-4 fixed lg:static">
      <div className="flex justify-between items-center">
        {/* Left side - Brand logo for mobile */}
        <div className="flex lg:hidden items-center">
          <Link to="/panel-admin/dashboard" className="flex items-center">
            <img src="https://dummyimage.com/150x150/cccccc/000000&text=Institution+Logo" alt="Institution LMS" className="h-8 ml-10" />
          </Link>
        </div>

        {/* Right side - Actions */}
        <div className="flex items-center ml-auto">
          {/* Theme toggle */}
          {/* <button
            onClick={toggleTheme}
            className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
            aria-label="Toggle theme"
            title="Toggle theme"
          >
            {isLightTheme ? (
              <Brightness4Icon className="h-5 w-5" />
            ) : (
              <Brightness7Icon className="h-5 w-5" />
            )}
          </button> */}

          {/* Logout button */}
          <button
            onClick={logout}
            className="ml-4 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
